import React, { useEffect } from "react";
import { Mic } from "lucide-react";
import TalksApi from "../../api/talksApi";
import { useAuthUser } from "../../hooks/useAuthUser";
import { useBilingualMasterData } from "../../hooks/useBilingualMasterData";
import BilingualMasterPage from "../../components/masterData/BilingualMasterPage";

const talksApi = new TalksApi();

const Talks = () => {
  const userData = useAuthUser();
  const {
    isError,
    validated,
    cp,
    icon_id,
    list: talksDataList,
    show,
    LoadData,
    deleteAlert,
    matches,
    showConfirmationModal,
    setShowConfirmationModal,
    data,
    handleClose,
    handleCloseAlert,
    handleShow,
    handleChanges,
    handleSubmit,
    handleConfirmSubmit,
    CollectData,
    DeleteData,
    SearchData,
    fetchList,
    clearfield,
    searchKey,
  } = useBilingualMasterData({
    emptyData: { talk: "", spanishTalk: "" },
    englishField: "talk",
    spanishField: "spanishTalk",
    api: {
      add: (payload) => talksApi.addTalk(payload),
      update: (payload, id) => talksApi.updateTalk(payload, id),
      remove: (payload, id) => talksApi.deleteTalk(payload, id),
      list: () => talksApi.getAllTalkList({} as any),
      search: (payload, key) => talksApi.searchTalk(payload, key),
    },
    getEditId: (item) => item.talkId,
    getDeleteId: (iconId) => iconId.talkId,
    sortList: (rows) => [...rows].sort((a, b) => a.talk.localeCompare(b.talk)),
    clearBeforeDelete: true,
    collectTransform: (item, empty) => ({
      ...empty,
      talk: item.talk,
      spanishTalk: item.spanishTalk || "",
    }),
  });

  useEffect(() => {
    if (searchKey) {
      SearchData({ target: { value: searchKey } });
    } else {
      fetchList();
    }
  }, []);

  return (
    <BilingualMasterPage
      isAdmin={Boolean(userData && userData.userRole === "ADMIN")}
      formTitle="Add Talk"
      listTitle="Talks"
      listSubtitle="Manage bilingual talk titles used on retreat programs."
      formIcon={<Mic size={20} color="#285d8f" />}
      listIcon={<Mic size={20} color="#285d8f" />}
      englishLabel="Talk"
      englishPlaceholder="Enter New Talk"
      englishRequiredMessage="Talk is required!"
      englishField="talk"
      spanishLabel="Spanish Talk"
      spanishPlaceholder="Enter Spanish Talk"
      spanishField="spanishTalk"
      englishColumnName="Talk"
      spanishColumnName="Spanish Talk"
      createdField="talkCreated"
      dataKey="talk"
      deleteTitle="Talk Detail"
      deleteDetailLabel="Talk"
      deleteAlertHeader="You are not able to delete this Talk"
      deleteAlertMessage={
        <div>
          <h4>Retreat Roster(s) are added for this Talk.</h4>{" "}
          <h5>
            If you want to delete this Talk, first please change the Talk for
            Retreat Rosters.
          </h5>
        </div>
      }
      isError={isError}
      validated={validated}
      cp={cp}
      icon_id={icon_id}
      list={talksDataList}
      show={show}
      LoadData={LoadData}
      deleteAlert={deleteAlert}
      matches={matches}
      showConfirmationModal={showConfirmationModal}
      setShowConfirmationModal={setShowConfirmationModal}
      data={data}
      handleClose={handleClose}
      handleCloseAlert={handleCloseAlert}
      handleShow={handleShow}
      handleChanges={handleChanges}
      handleSubmit={handleSubmit}
      handleConfirmSubmit={handleConfirmSubmit}
      CollectData={CollectData}
      DeleteData={DeleteData}
      SearchData={SearchData}
      clearfield={clearfield}
      searchValue={searchKey}
    />
  );
};
export default Talks;
